// Copyright (c) 2019 First Foundry Inc. All rights reserved.

import { graphql } from 'api/operationCompat'
import { getPackageChangeLog } from 'ops'
import { get } from 'lodash'
import { DEFAULT_TIMEZONE } from 'constants/Settings'
import moment from 'moment-timezone'

const withPriceGroupLogs =
  graphql(getPackageChangeLog, {
    name: 'packageChangeLogData',
    options: ({
      match,
      startTime,
      endTime,
      venueSettings,
    }) => {
      const storeTimezone = get(venueSettings, 'store.timezone', DEFAULT_TIMEZONE)
      return ({
        variables: {
          packageId: match.params.id,
          filter: { // Query store time in UTC
            startDt: moment.tz(startTime, storeTimezone).startOf('day').utc().toISOString(),
            endDt: moment.tz(endTime, storeTimezone).endOf('day').utc().toISOString(),
          },
        },
      })
    },
    skip: ({ selectedVenueId }) => !selectedVenueId,
  })

export default withPriceGroupLogs
